import { ForgotPasswordScreen } from 'app/features/auth/screens'
import { withAuthedPage } from 'lib/session'
import { GetServerSideProps } from 'next'

export default function Page() {
  return <ForgotPasswordScreen />
}

export const getServerSideProps: GetServerSideProps = withAuthedPage(async ({ req }) => {
  const user = req?.session?.user

  if (user?.token) {
    return {
      redirect: {
        destination: '/',
        permanent: false,
      },
    }
  }

  return {
    props: {},
  }
})
